module.exports = function (request, next) {
  /**
   * Intercept the outgoing requests.
   *
   * Set common headers on the request.
   */
  // request(request) {
  //   request.headers['X-XSRF-TOKEN'] = Cookies.get('XSRF-TOKEN');

  //   return request;
  // },

  /**
   * Intercept the incoming responses.
   *
   * Handle any unexpected HTTP errors and pop up modals, etc.
   */
  next(function (response) {
    switch (response.status) {
      case 401:
      case 419:
        // Vue.http.get('/logout');
        this.$root.$emit('bv::show::modal', 'modal-session-expired');
        break;

      case 402:
        Object.keys(this.$refs).forEach((key, index) => {
          if (key.includes('modal')) {
            try {
              this.$refs[key].hide();
            } catch (e) {

            }
          }
        });

        break;
    }

    return response;
  });
};
